import { useContext } from "react";
import { AthleteAuthContext } from "./AthleteAuthContext";

export const useAthleteAuthContext = () => {
    const context = useContext(AthleteAuthContext);
    if(!context){
        throw Error('useAthleteAuthContext must be used inside athlete pages');
    }
    return context;
}